import {
  initializeApp,
  getApps,
  getApp
} from "firebase/app";

import {
  getAuth,
  setPersistence,
  browserLocalPersistence
} from "firebase/auth";

import {
  getFirestore
} from "firebase/firestore";

const APP_NAME = "coadesc";

const firebaseConfig = {
  apiKey: "AIzaSyDAPUu0k3cqx-v1yos2MjbUnYXd2qX6fDs",
  authDomain: "coadesc-34711.firebaseapp.com",
  projectId: "coadesc-34711",
  storageBucket: "coadesc-34711.firebasestorage.app",
  messagingSenderId: "689475129073",
  appId: "1:689475129073:web:36deaa4b3f547dabd6a350",
  measurementId: "G-2Y7YTT6EZS"
};

const app = getApps().some(app => app.name === APP_NAME)
  ? getApp(APP_NAME)
  : initializeApp(firebaseConfig, APP_NAME);

export const auth = getAuth(app);

setPersistence(auth, browserLocalPersistence)
  .catch((error) => {
    console.warn("Persistência Auth:", error);
  });

export const db = getFirestore(app);

export default app;